import React from 'react';
import PropTypes from 'prop-types';

/**
 * NK Badge — voor NK SwimRun (19,5K duo's)
 * @param {Object} props
 * @param {string} props.title - The title of the badge
 * @returns {JSX.Element}
 */
export default function NkBadge({ title = 'NK SwimRun – 19,5K Duo' }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-label={title} role="img">
      <rect width="20" height="20" rx="10" fill="#e8700a" />
      {/* Twee figuren naast elkaar */}
      <circle cx="7" cy="7" r="2" fill="white" />
      <circle cx="13" cy="7" r="2" fill="white" />
      <path d="M4 15c0-2 1.3-4 3-4s3 2 3 4" fill="white" />
      <path d="M10 15c0-2 1.3-4 3-4s3 2 3 4" fill="white" />
    </svg>
  );
}

NkBadge.propTypes = {
  title: PropTypes.string,
};
